import React from 'react';
import { processJSX } from '../../utils/title-case';

const Heading1 = ({ title, extraClass = '' }) => {
  const renderedTitle = processJSX(title);

  return (
    <h1
      className={` ${extraClass} leading-none text-[43px] lg:text-6xl xl:text-7xl 2xl:text-8xl lg:tracking-[-4px] tracking-[-2px]`}>
      {renderedTitle}
    </h1>
  );
};

export default Heading1;
